import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, EventEmitter, Output } from '@angular/core';
import { ProcedureStatusDataService } from './shared/procedure-status-utility.data.service';
import { BaseControl} from '@app/shared';
import { ProcedureStatusFormService } from './shared/procedure-status-utility.form.service';

@Component({
  selector: 'iw-procedure-status-utility',
  templateUrl: './procedure-status-utility.component.html',
  styleUrls: ['./procedure-status-utility.component.scss'],
  providers: [ProcedureStatusDataService, ProcedureStatusFormService]
})
// type Template = "primary";
export class ProcedureStatusComponent implements OnInit, OnDestroy {
  // Texto de accion en el formulario
  actionForm = 'Actualizar estado de';
  status: any = [];
  // Contiene los controles de el formulario de asociaciones
  controls: BaseControl<any>[] = [];
  // Contiene el formulario
    formData = new FormData();
@Input() tramite: any = {};

// Emite la anulación para recargar el flujo
@Output() validStatus: EventEmitter<boolean> = new EventEmitter();

constructor(private psd: ProcedureStatusDataService,
        private cdRef: ChangeDetectorRef,
        private psf: ProcedureStatusFormService,
) { }

  ngOnInit() {
    // Consulta los estados de los expedientes
    this.psd.getStatus().subscribe((status: any[]) => {
      if (status && status.length) {
          status.forEach((obj: { id: any; nombre: any; }) => {
          this.status.push({
            key: obj.id,
            value: obj.nombre
          });
        });
        this.controls = this.psf.getFields(this.status, this.tramite.estado_expediente);
      }
    });
   
  }

  ngOnDestroy() {
    this.cdRef.detach();
    this.status = [];
    this.formData = new FormData();
  }

  sendedForm() {
    this.formData = new FormData();
    this.formData.append("expediente_estado", this.controls[0].value);
    this.formData.append("id", this.tramite.idExpediente);
    this.psd.changeStatus(this.formData).subscribe(() => {
        this.validStatus.emit(true);
    });
    
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/procedure-status-utility/procedure-status-utility.component.ts